import React, { Component } from 'react'
import config from '../../../resource/config.js'
import constants from '../../../resource/constants.js'
import InlineEditingGridData from './InlineEditingGridData.js'
const fixerrorsapi = config.apiBaseUrl + 'apbe/getErrorsAndWarnings'
const _ = require('lodash')



// Get Data from service
class InlineEditingGrid extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = { data: 'false', errorColumns: 'false', errorCategories: 'false', orgid: '', cognitoId: '', coordinator: '', isLoading: true }
    }

    componentDidMount() {
        fetch(fixerrorsapi, {
            method: 'POST',
            dataType: 'jsonp',
            headers: this.props.apiAuthHeaders,
            body: JSON.stringify({
                requestData: this.props.requestData
            })
        }).then((response) => {
            return response.json()
        }).then((responseData) => {
            if (responseData) {
                let columns = []
                const defaultColumns = responseData.defaultMergedColumns  // Get Column Data for all default and Dup columns and filter based on selection
                const filterableColumns = responseData.filterableColumns
                //const filterableColumnsNames = filterableColumns.map(col => col.value)
                const cols = defaultColumns.concat(filterableColumns)
                cols.forEach(col => {
                    //let editable = false
                    let colsToBeFiltered = columns
                    let filtered = colsToBeFiltered.filter(column => column.key === col.value)
                    if(filtered.length === 0){
                        columns.push({
                            key: col.value,
                            name: col.shortName,
                            editable: function(rowData) {
                                if(rowData.ERRORS){
                                    for(let i=0; i < rowData.ERRORS.length; i++) {
                                        if(rowData.ERRORS[i].FIELD_NAME === 'DUPLICATE' && _.includes(constants.duplicate_editable_cols, col.value))  // This makes only selected columns editable in Dups grid
                                            return true

                                        else if(col.shortName.includes('RACE') || col.shortName.includes('ETHN')
                                        || col.shortName.includes('ADDRESS') || col.shortName.includes('REGION')
                                        || col.shortName.includes('CITY')|| col.shortName.includes('STATE')
                                        || col.shortName.includes('ZIP')|| col.shortName.includes('COUNTRY') || col.shortName.includes('TEXT OPT-IN')
                                        || col.shortName.includes('MOBILE') || col.shortName.includes('COURSE CODE')|| col.shortName.includes('EXAM DATE')
                                        || col.shortName.includes('LATE REASON CODE')) {
                                            return true
                                        }

                                        else if(_.includes(rowData.ERRORS[i], col.value) && rowData.ERRORS[i].RECORD_TYPE === 'E') {
                                            return true
                                        }


                                    }
                                }
                            },
                            getRowMetaData: rowData => rowData,
                            resizable: true,
                            //width: function(rowData) {
                                    //if(col.value !== 'DUPLICATE')
                                        //return null
                                    //else
                                    //    return constants.file_column_custom_width[col.value]

                            //},
                            sortable: true
                        })
                    }
                })
                this.setState({
                    columns: columns,
                    data: responseData.gridData,
                    errorColumns: responseData.filterableColumns,
                    errorCategories: responseData.errorTypes,
                    defaultColumns: responseData.defaultColumns,
                    defaultDupColumns: responseData.defaultDupColumns,
                    defaultMergedColumns: responseData.defaultMergedColumns,
                    totalErrors: responseData.gridData.length,
                    totalErrorsMap: responseData.totalErrorsMap,
                    validationMetaData: responseData.validationMetaData,
                    isLoading: false
                })

            }
        }).catch(function (err) {
            console.log(err)
        })

    }


    render() {
        return (
            this.state.isLoading ?
            <div role="progressbar" aria-valuetext="Loading…" className="cb-loader cb-loader-blue cb-loader-lg"></div> :
            <InlineEditingGridData
                apiAuthHeaders={this.props.apiAuthHeaders}
                requestData={this.props.requestData}
                data={this.state.data}
                errorColumns={this.state.errorColumns}
                errorCategories={this.state.errorCategories}
                defaultColumns={this.state.defaultColumns}
                defaultDupColumns={this.state.defaultDupColumns}
                defaultMergedColumns={this.state.defaultMergedColumns}
                totalErrors={this.state.totalErrors}
                totalErrorsMap={this.state.totalErrorsMap}
                columns={this.state.columns}
                validationMetaData={this.state.validationMetaData}
            />
        )
    }
}

export default InlineEditingGrid
